import basicController from 'servicestack/basic.controller.properties'
import Product from 'emun.shopping/product.model'
import templateUrl from 'emun.stockchecker/stock-checker-product.htm'
import $session from 'servicestack/session'
import ProductQuery from 'emun.shopping/product-query.service'

class StockCheckerProductController {
    constructor($rootScope, $state, createAutoQuery, createServiceBus) {
        basicController(this)
        var id = this.productId;
        let options = {
            url: 'QueryProducts.json?Id=' + id,
            autoLoad: true,
            onLoaded: args => {
                this.product = new Product(args.first);
            }
        };
        this.slides = [];
        this.slides.push({
            image: 'http://b2bdemo.cms.emuncloud.com/media/1071/wood_black.jpeg',
            title: 'wood_black'
        });
        this.slides.push({
            image: 'http://b2bdemo.cms.emuncloud.com/media/1070/wood_antiquenatural.jpeg',
            title: 'wood_antiquenatural'
        });
        this.slides.push({
            image: 'http://b2bdemo.cms.emuncloud.com/media/1069/wood_antiquecoffee.jpeg',
            title: 'wood_antiquecoffee'
        });
        this.slides.push({
            image: 'http://b2bdemo.cms.emuncloud.com/media/1068/greyoak.jpeg',
            title: 'greyoak'
        });
        this.slides.push({
            image: 'http://b2bdemo.cms.emuncloud.com/media/1067/antiquetaupe.jpeg',
            title: 'antiqueaupe'
        });
        this.query = createAutoQuery(options);
        this.bus = createServiceBus($rootScope);
        this.$state = $state;
        this.$session = $session;
    }
}

let StockCheckerProduct = {
    controller: StockCheckerProductController,
    require:{
        container: '^stockChecker'
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

angular.module('emun.stockchecker').component('stockCheckerProduct', StockCheckerProduct);


